import * as React from "react";
import type { SVGProps } from "react";
const SvgIconPlayStore = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 14 14"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.45 0c-.2.03-.43.09-.57.16q-.66.33-.84 1L0 1.3v11.28l.04.13c.13.5.52.91 1.03 1.08.2.06.3.08.52.08.32 0 .5-.05.88-.24.9-.44 10.67-5.42 10.75-5.48.06-.03.17-.13.24-.2.55-.56.55-1.47 0-2.03l-.24-.2c-.08-.06-9.78-5-10.74-5.47C2.11.06 1.96.02 1.66 0zm3.11 3.75 2.38 2.38.76-.77c.43-.42.77-.77.77-.78L5.61 3.12l-3.14-1.6-.28-.14zM1.14 6.94v4.98l2.5-2.5 2.49-2.48-2.5-2.5-2.49-2.49zm7.5-.9-.9.9.91.9.9.9 1.5-.75c.82-.41 1.52-.78 1.55-.8.17-.12.17-.38 0-.5-.05-.04-3.02-1.56-3.04-1.56zm-4.08 4.08L2.19 12.5l.27-.13 3.12-1.6L8.46 9.3c.01 0-.28-.31-.75-.78l-.77-.77z"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconPlayStore;
